import { render, staticRenderFns } from "./Dictaphone.vue?vue&type=template&id=044bbf58&scoped=true&"
import script from "./Dictaphone.vue?vue&type=script&lang=js&"
export * from "./Dictaphone.vue?vue&type=script&lang=js&"
import style0 from "./Dictaphone.vue?vue&type=style&index=0&id=044bbf58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bbf58",
  null
  
)

export default component.exports